module.exports = __webpack_public_path__ + "img/slide3.fd49aeb2.jpg";